/**
 * useLiveReportsState — UI interaction wrappers for Live Reports.
 * Opening a report is pure navigation, so there is no local UI state to hold (no `useReducer`) —
 * add one when the list gains real interaction state (filters, selection, …). Fetch
 * (retry / refresh / loadMore) is called directly from the Screen via `useLiveReportsData`.
 */
import { useNavigation } from "@react-navigation/native"

import { type UILiveSessionReport } from "../../../types"

export function useLiveReportsState() {
    const navigation = useNavigation<{
        push: (name: string, params: { h: string }) => void
    }>()

    const actions = {
        openReport(report: UILiveSessionReport) {
            if (!report.hash) return
            navigation.push("r", { h: report.hash })
        },
    }

    return { actions }
}
